export enum ForceInvalidType {
	None = 'None',
	WithStatusIcon = 'WithStatusIcon',
	WithoutStatusIcon = 'WithoutStatusIcon',
}
